// types
import { i18nNavigation } from 'models/i18n';

// ==============================|| I18N EN NAVIGATION ||============================== //

const enNavigation: i18nNavigation = {
  dispatcher: {
    group: 'Operational management',
    onlineDispatching: 'Online dispatching',
    onlineDispatchingDeliveryPoint: 'Delivery point',
    onlineDispatchingDevice: 'Device',
    productionPlanning: 'Production planning',
    operationCalendar: 'Operation calendar',
    consumptionPlanning: 'Consumption planning',
    operatingCalendar: 'Operating calendar',
    hxDashboard: 'Anti-deviation H + X',
    rkDashboard: 'RK monitoring'
  },
  digiTwin: {
    group: 'DigiTwin'
  },
  reporting: {
    group: 'Reporting',
    marketImbalance: 'Market imbalance',
    balancingGroup: 'Balancing group',
    deviceProductionPlan: 'Device production plan',
    deliveryPointProductionPlan: 'Delivery point production plan',
    economicBenefits: 'Economic benefits of balancing group'
  },
  eai: {
    group: 'Resource management',
    users: 'Users',
    userList: 'User list',
    userDetail: 'User detail',
    userAssignment: 'User assignment',
    userWizard: 'Create user',
    subjects: 'Subjects',
    subjectList: 'Subject list',
    subjectDetail: 'Subject detail',
    subjectWizard: 'Create subject',
    balanceGroups: 'Balance groups',
    balanceGroupDetail: 'Balance group detail',
    deliveryPoints: 'Delivery points',
    deliveryPointList: 'Delivery point list',
    deliveryPointDetail: 'Delivery point detail',
    deliveryPointWizard: 'Crate delivery point',
    deliveryPointGdsList: 'GDS List',
    deliveryPointGdsDetail: 'GDS Detail',
    devices: 'Devices',
    deviceList: 'Device list',
    deviceDetail: 'Device detail',
    deviceWizard: 'Create device',
    deviceCharacteristicGroupWizard: 'Create device characteristic group',
    deviceGroupDetail: 'Device group',
    deliveryContracts: 'Long-term contracts',
    deliveryContractWizard: 'Create Long-term contract',
    deliveryContractDetail: 'Long-term contract detail'
  },
  system: {
    group: 'System management',
    activityEvents: 'Events overview',
    alarms: 'Alarms'
  }
};

export default enNavigation;
